import { useEffect, useState } from "react";
import axios from "axios";
import { useLang } from "@/App";
import { UI, tr } from "@/i18n";
import { Globe, Instagram } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const { lang } = useLang();
  const [cfg, setCfg] = useState({ website: "https://forinones.com", instagram: "https://instagram.com/forinones" });

  useEffect(() => {
    axios.get(`${API}/onematch/config`).then((r) => setCfg((c) => ({ ...c, ...r.data }))).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="mt-20 border-t border-border bg-navy-deep text-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <p className="font-display text-2xl">FORINONES <span className="text-gold">ONE MATCH™</span></p>
          <p className="mt-1 text-sm text-white/60">{tr(lang, UI.footer_tagline)}</p>
        </div>
        <div className="flex items-center gap-5">
          <a data-testid="footer-website" href={cfg.website} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 text-sm text-white/80 hover:text-gold transition-colors duration-300">
            <Globe className="w-4 h-4" /> {tr(lang, UI.visit_website)}
          </a>
          <a data-testid="footer-instagram" href={cfg.instagram} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 text-sm text-white/80 hover:text-gold transition-colors duration-300">
            <Instagram className="w-4 h-4" /> {tr(lang, UI.follow_instagram)}
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/50">
        © {new Date().getFullYear()} FORINONES. {tr(lang, UI.footer_rights)}
      </div>
    </footer>
  );
};

export default Footer;
